import { LocaleConfig } from "./locale";

/**
 * Configuration class to access environment variables.
 *
 * It ensures that required environment variables are set and provides access to them.
 */
export class Configuration {
  #locale;
  #externalGraphqlUrl;
  #externalRestUrl;
  #topDomain;

  constructor() {
    this.#locale = new LocaleConfig(
      this.#requireEnv(process.env.LOCALE, "LOCALE")
    );
    this.#externalGraphqlUrl = this.#requireEnv(
      process.env.EXTERNAL_GRAPHQL_URL,
      "EXTERNAL_GRAPHQL_URL"
    );
    this.#externalRestUrl = this.#requireEnv(
      process.env.EXTERNAL_REST_API_URL,
      "EXTERNAL_REST_API_URL"
    );
    this.#topDomain = this.#requireEnv(process.env.TOP_DOMAIN, "TOP_DOMAIN");
  }

  #requireEnv(value, name) {
    if (value === undefined || value === null || value.trim() === "") {
      throw new Error(`Environment variable ${name} is not set`);
    }
    return value;
  }

  /**
   * @returns {LocaleConfig} The locale set in the environment variable.
   */
  get locale() {
    return this.#locale;
  }

  /**
   * @returns {string} The URL of the external GraphQL API.
   */
  get externalGraphqlUrl() {
    return this.#externalGraphqlUrl;
  }

  /**
   * @returns {string} The URL of the external REST API.
   */
  get externalRestUrl() {
    return this.#externalRestUrl;
  }

  /**
   * @returns {string} The top domain used for routing.
   */
  get topDomain() {
    return this.#topDomain;
  }
}

export default new Configuration();
